import React, { useEffect, useState } from "react";
import { AppFilter } from "../../../models/app/AppModels";
import {
  Box,
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import ServerAppGrid from "../../../compenents/app/ServerAppGrid";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useGetCustomersMutation } from "../../../redux/reducer/features/Dealer/Customer/CustomersSlice";
import KeyIcon from "@mui/icons-material/Key";
import { ChangePassword } from "../../Customer/Profile/ChangePassword";
import { GetAppGridColumns } from "../../../services/utilities/utility";
import { AppGridId } from "../../../models/app/AppGridModels";
export const Customers: React.FunctionComponent = () => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find((x) => x.gridId === AppGridId.Customers)
  );

  const everestDmsDealerId = useSelector(
    (state: AppState) => state.authReducer.everestDmsDealerId
  );
  const [customersMutation, customersMutationResult] =
    useGetCustomersMutation();

  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 20,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [customers, setCustomers] = useState<any[]>([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState<any>("");
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [customersCount, setCustomersCount] = React.useState<number>(0);
  const fetchData = () => {
    customersMutation({
      paging: paging,
      everestDmsDealerId: everestDmsDealerId ?? "",
      search: paging.quickFilterValues.join(" "),
    }).then((response: any) => {
      if (response && response.data.status === 200) {
        setCustomers(response.data.entityList);
        setCustomersCount(response.data.totalRecords);
      }
    });
  };
  const handleOpenPassword = (id: string) => {
    setSelectedCustomerId(id);
    setOpenChangePassword(true);
  };
  const handleClose = () => {
    setOpenChangePassword(false);
  };
  useEffect(() => {
    fetchData();
  }, [paging]);

  useEffect(() => {
    console.log("selected Customer", selectedCustomerId);
  }, [selectedCustomerId]);

  const columns: GridColDef[] = [
    {
      field: "customerId",
      headerName: "Customer ID",
      width: 150,
    },
    {
      field: "customerNumber",
      headerName: "Customer Number",
      width: 150,
    },

    {
      field: "organizationName",
      headerName: "Organization Name",
      width: 250,
    },
    {
      field: "email",
      headerName: "Email",
      width: 250,
      editable: true,
      valueGetter: (params: GridValueGetterParams) =>
        params.row?.email !== null ? params.row?.email[0].address : "",
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
      editable: true,
      valueGetter: (params: GridValueGetterParams) =>
        params.row?.phone !== null ? params.row?.phone[0].phoneNumber : "",
    },
    {
      field: "address",
      headerName: "Address",
      width: 200,
      editable: true,
      valueGetter: (params: GridValueGetterParams) =>
        params.row?.address != null ? params.row?.address[0].address1 : "",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,

      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              onClick={(e: any) => {
                handleOpenPassword(params.row.customerId);
              }}
            >
              <KeyIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return (
    <Container maxWidth="xl">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Customers
        </Typography>
      </Stack>

      <Card>
        <ServerAppGrid
          gridId={AppGridId.Customers}
          data={customers.map((cus, index: number) => ({
            id: index,
            ...cus,
          }))}
          columns={GetAppGridColumns(
            columns,
            gridSetting?.columnVisibilityModel
          )}
          isLoading={customersMutationResult.isLoading}
          paging={paging}
          setPaging={setPaging}
          totalRecords={customersCount}
          hideCheckBoxes={true}
        />
      </Card>
      <Dialog open={openChangePassword} onClose={handleClose}>
        <DialogTitle textAlign="center">Change Password</DialogTitle>
        <DialogContent>
          <ChangePassword
            Id={selectedCustomerId}
            handleClose={handleClose}
          ></ChangePassword>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};
